import { filterInstances, filterKeys, ImplementationMissingException, MUSTNeverHappenException } from '@nu-art/ts-common';
import { valueType_EnumElement, valueType_Enumerated, valueType_Range, valueType_StandardRange, valueType_SubEnumerated, valueType_SubRange, valueType_SubTime, valueType_Time, valueType_TimeRange, valueType_Tuple } from './consts.js';
export const convertValueDBToUI = (dbValue, maps) => {
    if (!dbValue) {
        console.error('Tried to convert db-> ui value, but did not receive any DB Value!');
        return undefined;
    }
    const uiValue = {};
    //Simple Data
    uiValue._id = dbValue?._id;
    uiValue._v = dbValue?._v;
    uiValue.__created = dbValue?.__created;
    uiValue.__updated = dbValue?.__updated;
    uiValue.type = dbValue?.type;
    uiValue._rowId = dbValue?._rowId;
    //Inner Data
    switch (dbValue.type) {
        case valueType_SubRange:
            uiValue.data = dbValue.data;
            break;
        case valueType_SubEnumerated: {
            const _dbValue = dbValue;
            const scope = filterInstances(_dbValue.data.scope?.map(id => {
                const value = maps.values[id];
                return convertValueDBToUI(value, maps);
            }));
            uiValue.data = {
                scope,
                label: _dbValue.label,
                parentId: _dbValue.data.parentId,
            };
            break;
        }
        case valueType_SubTime: {
            const value = dbValue;
            const _uiValue = uiValue;
            const parent = convertValueDBToUI(maps.values[value.data.parentId], maps);
            const scope = filterInstances(value.data.scope.map(id => convertValueDBToUI(maps.values[id], maps)));
            if (!parent)
                throw new MUSTNeverHappenException(`Could not convert parent value with id ${value.data.parentId} to UI value`);
            _uiValue.data = {
                scope,
                parent
            };
            break;
        }
        case valueType_EnumElement:
            uiValue.data = dbValue.data;
            break;
        case valueType_TimeRange:
            uiValue.data = dbValue.data;
            break;
        case valueType_Enumerated: {
            const _dbValue = dbValue;
            const scope = filterInstances(_dbValue.data.scope?.map(id => {
                const value = maps.values[id];
                return convertValueDBToUI(value, maps);
            }));
            uiValue.data = {
                scope,
                subsets: [],
                subsetIds: [],
                props: _dbValue.data.props,
            };
            break;
        }
        case valueType_Range: {
            const _dbValue = dbValue;
            const subsets = filterInstances(_dbValue.data.subsets.map(id => {
                const value = maps.values[id];
                return convertValueDBToUI(value, maps);
            }));
            uiValue.data = filterKeys({
                subsets,
                subsetIds: filterInstances(subsets.map(item => item._id)),
                scope: _dbValue.data.scope,
                measurementUnit: maps.measurementUnits[_dbValue.data.unitsId],
            }, 'measurementUnit');
            break;
        }
        case valueType_Tuple: {
            const _dbValue = dbValue;
            const scope = filterInstances(_dbValue.data.scope?.map(id => {
                const value = maps.values[id];
                return convertValueDBToUI(value, maps);
            }));
            uiValue.data = {
                scope,
            };
            break;
        }
        case valueType_StandardRange: {
            const _dbValue = dbValue;
            uiValue.data = {
                normalValues: _dbValue.data.normalValues || [],
                fullRange: _dbValue.data.fullRange,
                declarationVarIds: _dbValue.data.declarationVarIds,
                measurementUnit: maps.measurementUnits[_dbValue.data.unitsId],
            };
            break;
        }
        case valueType_Time: {
            const _dbValue = dbValue;
            uiValue.data = {
                timeRangesIds: _dbValue.data.timeRanges,
                timeRanges: filterInstances(_dbValue.data.timeRanges.map(valueId => maps.values[valueId]))
            };
            break;
        }
        default: {
            throw new ImplementationMissingException(`No implementation for type ${dbValue.type}`);
        }
    }
    return uiValue;
};
//# sourceMappingURL=ui-db-conversion.js.map